import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useDeleteTrialEmployees from 'modules/employees/hooks/useDeleteTrialEmployees'

type Props = {
  onClose: () => void
  onSuccess: () => void
}

const TrialEmployeeDeleteModal = ({ onClose, onSuccess }: Props) => {
  const { bulkDelete, loading } = useDeleteTrialEmployees()

  const handleSubmit = async () => {
    const response = await bulkDelete()

    const result = handleResult(response, () => {
      // TODO: Why is this mandatory?
    })
    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
      onSuccess()
    }
    onClose()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('trial_employees.modal.title')}
      description={i18n.t('trial_employees.modal.description')}
      onSubmit={handleSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('trial_employees.modal.cancel')}
          </Button>
          <Button loading={loading} disabled={loading} submit>
            {i18n.t('trial_employees.modal.confirm')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <Text.Normal>{i18n.t('trial_employees.modal.continue')}</Text.Normal>
      </Box>
    </Modal>
  )
}

export default TrialEmployeeDeleteModal
